import { Card } from "@/components/ui/card";

export const EmptyState = () => {
  return (
    <Card className="p-8 text-center text-muted-foreground">
      Aucune question n'a été créée pour ce chapitre.
    </Card>
  );
};